import React, { useEffect, useRef, useState } from 'react';
import { Draggable } from '@fullcalendar/interaction';
import './ItemList.css';
import { Button, TextField, Box } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
const ItemList = ({
  items,
  setItems
}) => {
  const draggableRef = useRef(null);
  const [isEditable, setIsEditable] = useState(false);
  const [enteredTitle, setEnteredTitle] = useState("");
  useEffect(() => {
    if (draggableRef.current) {
      let draggable = new Draggable(draggableRef.current, {
        itemSelector: '.draggable-item',
        eventData: eventEl => {
          const itemId = eventEl.getAttribute('data-id');
          const item = items.find(item => item.id === itemId);
          return {
            title: item?.title
          };
        }
      });
      return () => draggable.destroy();
    }
  }, [items]);
  const addNewItem = e => {
    e.preventDefault();
    let title = enteredTitle.trim();
    if (title === '') {
      alert('Item cannot be empty');
      return;
    }
    const newItem = {
      // id: String(items.length + 1 + 100), // Generate a new ID
      id: uuidv4(),
      title
    };
    setIsEditable(false);
    setEnteredTitle("");
    setItems([...items, newItem]);
  };
  const handleAddClose = () => {
    setIsEditable(false);
    setEnteredTitle("");
  };
  return <div className='itemsHome'>
    <div className='instruction-container'><instruct className="migrated-style-itemlist-4546b6-1"><strong>Note:&nbsp;</strong><span>Drag and drop the items on calendar to schedule. </span></instruct></div>
    <h3>Map your Program/Certificate Learning Journey</h3>

    <div className='items-list' ref={draggableRef}>
      {items.map(item => <div key={item.id} className="draggable-item" data-id={item.id}>
          {item.title}
        </div>)}
    </div>
    <div className='add'>
      {isEditable ? <Box className='item-form' component="form" onSubmit={addNewItem}>
          <TextField variant='standard' value={enteredTitle} required onChange={e => setEnteredTitle(e.target.value)} placeholder='Enter item here...' fullWidth />
            <div className="migrated-style-itemlist-4546b6-2">
          <div className="migrated-style-itemlist-4546b6-3">
            <button type="submit" className="filled-btn">
              Add
            </button>
            <button onClick={handleAddClose} className="outlined-btn">
              Cancel
            </button>
          </div>
          </div>
        </Box> : <button onClick={() => setIsEditable(true)} className='add-items-btn'> + Add Item</button>}
    </div>
  </div>;
};
export default ItemList;
